export const TIME_TO_REQUIRE_MERCHANT_ATTENTION = 180;
export const TIME_TO_REQUIRE_MANAGEMENT_ATTENTION = 60;
export const alertMap = {
  white: {
    icon: '⚪',
    title: 'All Good',
    subtitle: '',
    type: 'General',
  },
  green: {
    icon: '🟢',
    title: 'Active',
    subtitle: 'This order last mile shift is currently active',
    type: 'General',
  },
  // Management
  red: {
    icon: '🔴',
    title: 'Management Urgent Attention',
    subtitle:
      "This shipment is with Captain, and it's shift has ended but it is still not delivered to Silal/Customer/Store",
    type: 'Management',
  },
  brown: {
    icon: '🟤',
    title: 'Management Attention',
    subtitle: `This shipment is with Captain, it\'s shift is ending in less than ${TIME_TO_REQUIRE_MANAGEMENT_ATTENTION} minutes, check the Captains status delivered to Silal/Customer/Store`,
    type: 'Management',
  },
  purple: {
    icon: '🟣', //
    title: 'Reschedule',
    subtitle: 'This order needs to be rescheduled',
    type: 'Management',
  },
  // Merchant
  orange: {
    icon: '🟠',
    title: 'Merchant Urgent Attention',
    subtitle: `Not marked as ready yet & shift start time is less than ${TIME_TO_REQUIRE_MERCHANT_ATTENTION} minutes away`,
    type: 'Merchant',
  },
  yellow: {
    icon: '🟡',
    title: 'Merchant Attention',
    subtitle: 'Order is not marked as ready yet',
    type: 'Merchant',
  },
  blue: {
    icon: '🔵',
    title: 'Merchant Attention',
    subtitle: 'Order is not accepted yet',
    type: 'Merchant',
  },
  black: {
    icon: '⚫',
    title: 'Merchant Penalty',
    subtitle: 'Shift has started and the order is not marked as ready yet',
    type: 'Merchant',
  },
};
